import { render, staticRenderFns } from "./DefVersion.vue?vue&type=template&id=0290cd9c&scoped=true&"
import script from "./DefVersion.vue?vue&type=script&lang=js&"
export * from "./DefVersion.vue?vue&type=script&lang=js&"
import style0 from "./DefVersion.vue?vue&type=style&index=0&id=0290cd9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0290cd9c",
  null
  
)

export default component.exports